'use client'

import { useIsDesktop } from '@/_hooks/useBreakpoint'
import React from 'react'
import { IRecipe } from '@/_types'
import Desktop from './responsive/desktop'
import Mobile from './responsive/mobile'
import type { RecipeReviewsPayload } from './types'

const SingleRecipe = ({
  data,
  reviews,
}: {
  data: IRecipe
  reviews?: RecipeReviewsPayload
}) => {
  const isDesktop = useIsDesktop()

  return isDesktop ? (
    <Desktop data={data} reviews={reviews} />
  ) : (
    <Mobile data={data} reviews={reviews} />
  )
}

export default SingleRecipe
